import { render } from "./logistics_type.vue?vue&type=template&id=62d00724&scoped=true&ts=true"
import script from "./logistics_type.vue?vue&type=script&lang=ts"
export * from "./logistics_type.vue?vue&type=script&lang=ts"

import "./logistics_type.vue?vue&type=style&index=0&id=62d00724&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d00724"]])

export default __exports__